import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/users/constants';
import { usersQueryKeys } from '@/modules/users/queries/queryKeys';

/**
 * `PUT /users/me/meeting-url`: sets the signed-in user's booking link, which
 * hiring manager pre-screening sends to candidates. It can be replaced but not
 * cleared, so callers only send a non-empty URL.
 */
export const useUpdateMeetingUrlMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (meetingUrl: string) => {
      const { data } = await fetchClient.PUT(endpoints.currentUserMeetingUrl, {
        body: { meetingUrl },
      });
      return data;
    },
    onSuccess: (user) => {
      if (user) queryClient.setQueryData(usersQueryKeys.current(), user);
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: usersQueryKeys.current(),
      });
    },
  });
};
